// extracted by mini-css-extract-plugin
module.exports = {"LazyLoadingFallback":"LazyLoadingFallback_LazyLoadingFallback__2F4Uk","Loading":"LazyLoadingFallback_Loading__35RTG","Text":"LazyLoadingFallback_Text__q10gt"};